import request from '@/utils/requestV2'

/**
 * 查询经营权费的月度数据
 * @param {Object} data
 */
export function listMonthFee (data) {
  return request(
    {
      url: '/ooh-bill/right/fee/listMonthFee',
      method: 'get',
      params: data
    }
  )
}
